<template>
    <base-dialog @close="close" :open="show" newClass="vehicle-picker-modal__panel vehicle-picker-modal__panel--active">
        <template #default>
            <div class="" data-panel="form">
                <div class="vehicle-picker-modal__title card-title">{{titleCaption}}</div>
                <div class="vehicle-form vehicle-form--layout--modal">
                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="DD1Show === true">
                        <select class="form-control" aria-label="Year" @change="getKitMakes" v-model="lsel_year">
                            <option value="" selected>Select {{lvl2n.caption}}</option>
                            <option :value="yr.DMCD02" v-for="(yr, index) in lyears" :key="index">
                                {{yr.categoryname}}
                            </option>
                        </select>
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="DD2Show === true">
                        <select class="form-control" aria-label="Make" v-model="lsel_make" :disabled="(lmakes.length == 0)" @change="getKitEngines">
                            <option value="" selected>Select {{lvl3n.caption}}</option>
                            <option :value="mk.DMCD03" v-for="(mk, index) in lmakes" :key="index">
                                {{mk.categoryname}}
                            </option>
                        </select>
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="DD3Show === true">
                        <select class="form-control" aria-label="Engine" v-model="lsel_eng" :disabled="(lengines.length == 0)" @change="getKitVIN">
                            <option value="" selected>Select {{lvl4n.caption}}</option>
                            <option :value="eng.DMCD04" v-for="(eng, index) in lengines" :key="index">
                                {{eng.categoryname}}
                            </option>
                        </select>
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="DD4Show === true">
                        <select class="form-control" aria-label="VIN Code" v-model="lsel_vin" :disabled="(lvins.length == 0)" @change="getLvl6">
                            <option value="" selected>Select
                                <!-- {{lvl5n.caption}} -->
                            </option>
                            <option :value="vin.DMCD05" v-for="(vin, index) in lvins" :key="index">
                                {{vin.categoryname}}
                            </option>
                        </select>
                    </div>
                    <div class=" vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="lvl6s.length > 0 && DD5Show === true">
                        <select class="form-control" aria-label="Select level 6" v-model="lsel_lvl6" :disabled="(lvl6s.length == 0)" @change="getLvl7">
                            <option value="" selected>Select {{lvl6n.caption}}</option>
                            <option :value="vin.DMCD06" v-for="(vin, index) in lvl6s" :key="index">
                                {{vin.categoryname}}
                            </option>
                        </select>
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="lvl7s.length > 0 && DD6Show === true">
                        <select class="form-control" aria-label="Select level 7" v-model="lsel_lvl7" :disabled="(lvl7s.length == 0)" @change="getLvl8">
                            <option value="" selected>Select {{lvl7n.caption}}</option>
                            <option :value="vin.DMCD07" v-for="(vin, index) in lvl7s" :key="index">
                                {{vin.categoryname}}
                            </option>
                        </select>
                    </div>

                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="lvl8s.length > 0 && DD7Show === true">
                        <select class="form-control" aria-label="Select level 7" v-model="lsel_lvl8" :disabled="(lvl8s.length == 0)" @change="getLvl9">
                            <option value="" selected>Select {{lvl8n.caption}}</option>
                            <option :value="vin.DMCD08" v-for="(vin, index) in lvl8s" :key="index">
                                {{vin.categoryname}}
                            </option>
                        </select>
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="lvl9s.length > 0 && DD8Show === true">
                        <select class="form-control" aria-label="Select level 7" v-model="lsel_lvl9" :disabled="(lvl9s.length == 0)" @change="getLvl10">
                            <option value="" selected>Select {{lvl9n.caption}}</option>
                            <option :value="vin.DMCD09" v-for="(vin, index) in lvl9s" :key="index">
                                {{vin.categoryname}}
                            </option>
                        </select>
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select col-md-6 col-xs-12 " v-if="lvl10s.length > 0 && DD9Show === true">
                        <select class="form-control" aria-label="Select level 7" v-model="lsel_lvl10" :disabled="(lvl10s.length == 0)">
                            <option value="" selected>Select {{lvl10n.caption}}</option>
                            <option :value="vin.DMCD10" v-for="(vin, index) in lvl10s" :key="index">
                                {{vin.categoryname}}
                            </option>
                        </select>
                    </div>

                    <div class="vehicle-form__divider" >Or</div>
                    <div class="vehicle-form__item col-md-12 col-xs-12">
                        <select class="form-control " aria-label="Previously Selected Vehicles" v-model="lsel_saved" @change="goToResults($event.target.value)">
                            <option value="">Previously Selected Vehicles</option>
                            <option v-for="(option, index) in savedEngines" :value="option.LASTTEXT" :key="index">
                                {{option.caption}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </template>
        <template #actions>
            <button class="btn btn-primary btn-sm" @click="goToKit" :disabled="allowSearch">{{ buttonCaption }}</button>
        </template>
    </base-dialog>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import product from "../../../mixins/product";

export default {
    mixins: [product],
    data () {
        return {
            maxLevel: 5,
            // selected fields
            lsel_year: '',
            lsel_make: '',
            lsel_eng: '',
            lsel_vin: '',
            lsel_lvl6: '',
            lsel_lvl7: '',
            lsel_lvl8: '',
            lsel_lvl9: '',
            lsel_lvl10: '',
            lsel_saved: '',
            lsel_option: {},

            engine_kit: [],
            lyears : [],
            lmakes : [],
            lengines : [],
            lvins : [],
            lvl6s : [],
            lvl7s : [],
            lvl8s : [],
            lvl9s : [],
            lvl10s : [],

            savedEngines: [],
            titleCaption : '',
            buttonCaption: '',

            DD1Show: true,
            DD2Show: true,
            DD3Show: true,
            DD4Show: true,
            DD5Show: false,
            DD6Show: false,
            DD7Show: false,
            DD8Show: false,
            DD9Show: false,

            lvl1n : {},
            lvl2n : {},
            lvl3n : {},
            lvl4n : {},
            lvl5n : {},
            lvl6n : {},
            lvl7n : {},
            lvl8n : {},
            lvl9n : {},
            lvl10n : {},
        }
    },

    props: {
        main_category: {
            type: String
        },
        show: {
            type: Boolean
        },
    },

    watch: {
        main_category(newVal) {
            if (newVal == 'ENGKT'){
                this.titleCaption = 'Select Engine';
                this.buttonCaption = 'Search Kits';
                this.DD1Show = true;
                this.DD2Show = true;
                this.DD3Show = true;
                this.DD4Show = true;
            }else{
                this.titleCaption = 'Select Vehicle';
                this.buttonCaption = 'View Products';
            }
        }
    },

    computed: {
        allowSearch(){
            let allow = false;

            if (this.main_category == 'ENGKT'){
                if((this.lsel_year == '' || this.lsel_make == '' || this.lsel_eng == '' || this.lsel_vin == '') && this.lsel_saved == '' )
                    allow = true;
                
                return allow;
            }else{
                if(this.lsel_year == '')
                    allow = true;
            }

            return allow;
        },

    },

    methods: {
        getYears() {
            this.clearValues();

            let categories = this.$store.getters['product/categories'];
            this.engine_kit = categories.filter(c => c.DMCD01 == this.main_category);

            this.engine_kit.forEach(eng => {
                var i = this.lyears.findIndex(y => {y.DMCD02 == eng.DMCD02 });
                if(i <= -1 && eng.DMCD02 != '' && eng.categorylevel == 2){
                    this.lyears.push(eng);
                }
            });

            // descending
            if(this.lvl2n.sort == 'D'){
                this.lyears.sort((a,b) => (a.DMCD02 < b.DMCD02) ? 1 : ((b.DMCD02 < a.DMCD02) ? -1 : 0));
            }else{
                this.lyears.sort((a,b) => (a.DMCD02 > b.DMCD02) ? 1 : ((b.DMCD02 > a.DMCD02) ? -1 : 0));
            }
            // console.log(this.lyears);
        },

        getKitMakes() {
            this.lmakes = [];
            if(this.lsel_year != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lmakes.findIndex(y => {y.DMCD03 == eng.DMCD03});
                    if(i <= -1 && eng.DMCD02 == this.lsel_year && eng.categorylevel == 3){
                        this.lmakes.push(eng);
                    }
                });

                if(this.lvl3n.sort == 'A'){
                    this.lmakes.sort((a,b) => (a.DMCD03 < b.DMCD03) ? 1 : ((b.DMCD03 < a.DMCD03) ? -1 : 0));
                }else{
                    this.lmakes.sort((a,b) => (a.DMCD03 > b.DMCD03) ? 1 : ((b.DMCD03 > a.DMCD03) ? -1 : 0));
                }    
                
            }else{
                this.lengines = [];
                this.lvins = [];
                this.lsel_make = '';
                this.lsel_eng = '';
                this.lsel_vin = '';
                this.lsel_lvl6 = '';
                this.lsel_lvl7 = '';
                this.lsel_lvl8 = '';
                this.lsel_lvl9 = '';
            }
        },

        getKitEngines() {
            this.lengines = [];

            if(this.lsel_make != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lengines.findIndex(y => {y.DMCD04 == eng.DMCD04});
                    if(i <= -1 && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 4){
                        this.lengines.push(eng);
                    }
                });

                if(this.lvl4n.sort == 'D'){
                    this.lengines.sort((a,b) => (a.DMCD04 < b.DMCD04) ? 1 : ((b.DMCD04 < a.DMCD04) ? -1 : 0));
                }else{
                    this.lengines.sort((a,b) => (a.DMCD04 > b.DMCD04) ? 1 : ((b.DMCD04 > a.DMCD04) ? -1 : 0));
                }
                
            }else{
                this.lvins = [];
                this.lsel_eng = '';
                this.lsel_vin = '';
                this.lsel_lvl6 = '';
                this.lsel_lvl7 = '';
                this.lsel_lvl8 = '';
                this.lsel_lvl9 = '';
            }
        },

        getKitVIN() {
            this.lvins = [];
            if(this.lsel_eng != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lvins.findIndex(y => {y.DMCD05 == eng.DMCD05});
                    if(i <= -1 && eng.DMCD04 == this.lsel_eng && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 5){
                        this.lvins.push(eng);
                    }
                });

                if(this.lvl5n.sort == 'D'){
                    this.lvins.sort((a,b) => (a.DMCD05 < b.DMCD05) ? 1 : ((b.DMCD05 < a.DMCD05) ? -1 : 0));
                }else{
                    this.lvins.sort((a,b) => (a.DMCD05 > b.DMCD05) ? 1 : ((b.DMCD05 > a.DMCD05) ? -1 : 0));
                }
            }else{
                this.lsel_vin = '';
                this.lsel_lvl6 = '';
                this.lsel_lvl7 = '';
                this.lsel_lvl8 = '';
                this.lsel_lvl9 = '';
            }
        },

        getLvl6() {
            this.lvl6s = [];
            if(this.lsel_vin != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lvl6s.findIndex(y => {y.DMCD06 == eng.DMCD06});
                    // console.log(i);
                    if(i <= -1 && eng.DMCD05 == this.lsel_vin && eng.DMCD04 == this.lsel_eng && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 6){
                        this.maxLevel = 6;
                        this.lvl6s.push(eng);
                    }
                });

                if(this.lvl6n.sort == 'D'){
                    this.lvl6s.sort((a,b) => (a.DMCD06 < b.DMCD06) ? 1 : ((b.DMCD06 < a.DMCD06) ? -1 : 0));
                }else{
                    this.lvl6s.sort((a,b) => (a.DMCD06 > b.DMCD06) ? 1 : ((b.DMCD06 > a.DMCD06) ? -1 : 0));
                }

            }else{
                this.lsel_lvl6 = '';
                this.lsel_lvl7 = '';
                this.lsel_lvl8 = '';
                this.lsel_lvl9 = '';
            }
        },

        getLvl7() {
            this.lvl7s = [];
            if(this.lsel_vin != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lvl7s.findIndex(y => {y.DMCD07 == eng.DMCD07});
                    // console.log(i);
                    if(i <= -1 && eng.DMCD06 == this.lsel_lvl6 && eng.DMCD05 == this.lsel_vin && eng.DMCD04 == this.lsel_eng && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 7){
                        this.maxLevel = 7;
                        this.lvl7s.push(eng);
                    }
                });

                if(this.lvl7n.sort == 'D'){
                    this.lvl7s.sort((a,b) => (a.DMCD07 < b.DMCD07) ? 1 : ((b.DMCD07 < a.DMCD07) ? -1 : 0));
                }else{
                    this.lvl7s.sort((a,b) => (a.DMCD07 > b.DMCD07) ? 1 : ((b.DMCD07 > a.DMCD07) ? -1 : 0));
                }

                // console.table(this.lvl7s);
            }else{
                this.lsel_lvl7 = '';
                this.lsel_lvl8 = '';
                this.lsel_lvl9 = '';
            }
        },

        getLvl8() {
            this.lvl8s = [];
            if(this.lsel_vin != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lvl8s.findIndex(y => {y.DMCD08 == eng.DMCD08});
                    // console.log(i);
                    if(i <= -1  && eng.DMCD07 == this.lsel_lvl7 && eng.DMCD06 == this.lsel_lvl6 && eng.DMCD05 == this.lsel_vin && eng.DMCD04 == this.lsel_eng && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 8){
                        this.maxLevel = 8;
                        this.lvl8s.push(eng);
                    }
                });

                if(this.lvl8n.sort == 'D'){
                    this.lvl8s.sort((a,b) => (a.DMCD08 < b.DMCD08) ? 1 : ((b.DMCD08 < a.DMCD08) ? -1 : 0));
                }else{
                    this.lvl8s.sort((a,b) => (a.DMCD08 > b.DMCD08) ? 1 : ((b.DMCD08 > a.DMCD08) ? -1 : 0));
                }

                // console.table(this.lvl8s);
            }else{
                this.lsel_lvl8 = '';
                this.lsel_lvl9 = '';
            }
        },

        getLvl9() {
            this.lvl9s = [];
            if(this.lsel_vin != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lvl9s.findIndex(y => {y.DMCD09 == eng.DMCD09});
                    // console.log(i);
                    if(i <= -1 && eng.DMCD08 == this.lsel_lvl8 && eng.DMCD07 == this.lsel_lvl7 && eng.DMCD06 == this.lsel_lvl6 && eng.DMCD05 == this.lsel_vin && eng.DMCD04 == this.lsel_eng && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 9){
                        this.maxLevel = 9;
                        this.lvl9s.push(eng);
                    }
                });

                if(this.lvl9n.sort == 'D'){
                    this.lvl9s.sort((a,b) => (a.DMCD09 < b.DMCD09) ? 1 : ((b.DMCD09 < a.DMCD09) ? -1 : 0));
                }else{
                    this.lvl9s.sort((a,b) => (a.DMCD09 > b.DMCD09) ? 1 : ((b.DMCD09 > a.DMCD09) ? -1 : 0));
                }

                // console.table(this.lvl9s);
            }else{
                this.lsel_lvl9 = '';
            }
        },

        getLvl10() {
            this.lvl10s = [];
            if(this.lsel_vin != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lvl10s.findIndex(y => {y.DMCD10 == eng.DMCD10});
                    // console.log(i);
                    if(i <= -1 && eng.DMCD09 == this.lsel_lvl9 && eng.DMCD08 == this.lsel_lvl8 && eng.DMCD07 == this.lsel_lvl7 && eng.DMCD06 == this.lsel_lvl6 && eng.DMCD05 == this.lsel_vin && eng.DMCD04 == this.lsel_eng && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 9){
                        this.maxLevel = 10;
                        this.lvl10s.push(eng);
                    }
                });

                if(this.lvl9n.sort == 'D'){
                    this.lvl10s.sort((a,b) => (a.DMCD10 < b.DMCD10) ? 1 : ((b.DMCD10 < a.DMCD10) ? -1 : 0));
                }else{
                    this.lvl10s.sort((a,b) => (a.DMCD10 > b.DMCD10) ? 1 : ((b.DMCD10 > a.DMCD10) ? -1 : 0));
                }

                // console.table(this.lvl10s);
            }else{
                this.lsel_lvl9 = '';
            }
        },

        goToKit() {
            this.$emit('close');
            const cat_uri = (this.main_category != 'ENGKT') ? 'category' : 'sub-category';
            // const cat_uri = 'sub-category';
            let names_uri = '';
            let mx_uri = '';
            // const cat_uri = 'sub-category';
            let uri = '/' + cat_uri +'/' + this.maxLevel + '/' + this.main_category;

            let mname = null;

            if(this.maxLevel >= 2){
                const yname = this.lyears.find(y => y.DMCD02 == this.lsel_year).categoryname;
                mx_uri = this.mx_category_uri(this.lyears.find(y => y.DMCD02 == this.lsel_year));
                uri = mx_uri;
                names_uri +=  '/' + yname;
            }

            if(this.maxLevel >= 3){
                if(this.lsel_make != ''){
                    mname = this.lmakes.find(y => y.DMCD03 == this.lsel_make).categoryname;
                    mx_uri = this.mx_category_uri(this.lmakes.find(y => y.DMCD03 == this.lsel_make));
                    uri = mx_uri;
                    names_uri +=  '/' + mname;
                }else{
                    mx_uri = this.mx_category_uri(this.lyears.find(y => y.DMCD02 == this.lsel_year));
                    uri = uri.replace('/' + this.maxLevel + '/', '/2/');
                    this.goToPage(uri + names_uri);
                    return;
                }
            }

            if(this.maxLevel >= 4){
                if(this.lsel_eng != ''){
                    const ename = this.lengines.find(y => y.DMCD04 == this.lsel_eng).categoryname;
                    mx_uri = this.mx_category_uri(this.lengines.find(y => y.DMCD04 == this.lsel_eng));
                    uri = mx_uri;

                    names_uri +=  '/' + ename;
                }else{
                    mx_uri = this.mx_category_uri(this.lmakes.find(y => y.DMCD03 == this.lsel_make));
                    this.goToPage(mx_uri + names_uri);
                    return;
                }   
            }

            if(this.maxLevel >= 5){
                if(this.lsel_vin != ''){
                    mx_uri = this.mx_category_uri(this.lvins.find(y => y.DMCD05 == this.lsel_vin));
                    const vname = this.lvins.find(y => y.DMCD05 == this.lsel_vin).categoryname;
                    uri = mx_uri;
                    names_uri +=  '/' + vname;
                }else{
                    // uri = uri.replace('/' + this.maxLevel + '/', '/4/');
                    mx_uri = this.mx_category_uri(this.lengines.find(y => y.DMCD04 == this.lsel_eng));
                    this.goToPage(mx_uri + names_uri);
                    return;
                }
            }
            
            if(this.maxLevel > 5){
                let lvl = 6;
                while(lvl <= this.maxLevel){
                    uri += '/' + this['lsel_lvl' + lvl];
                    lvl++;
                }
            }

            this.goToPage(uri + names_uri);
        },

        goToPage(uri){
            // console.log(uri);
            this.$router.push(uri);
        },

        clearValues() {
            this.maxLevel= 5;
            // clear the value of the options when closed
            this.lyears = [];
            this.lmakes = [];
            this.lengines = [];
            this.lvins = [];
            this.lvl6s = [];
            this.lvl7s = [];
            this.lvl8s = [];
            this.lvl9s = [];
            this.lvl10s = [];

            this.lsel_year = '',
            this.lsel_make = '',
            this.lsel_eng = '',
            this.lsel_vin = '',
            this.lsel_lvl6 = '';
            this.lsel_lvl7 = '';
            this.lsel_lvl8 = '';
            this.lsel_lvl9 = '';
            this.lsel_lvl10 = '';

            this.lsel_saved = '';
        },

        close(){
            this.clearValues();

            this.$emit('close');
        },

        lastCategories() {
            const last_cat_uri = this.$store.getters['api/last_category_uri'];
            this.savedEngines = [];
            axiosvl.post(last_cat_uri, {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                    },   
                }
            })
            .then((response) => {
                const CATLAST = response.data.webroutine.lists.CATLAST.entries;

                CATLAST.forEach(cat => {
                    if(cat.DMCD01 != this.main_category){
                        return false;
                    }

                    if(cat.DMCD02 == '' || cat.DMCD03 == '' || cat.DMCD04 == '' || cat.DMCD05 == ''){
                        return false;
                    }

                    const myArray = cat.LASTTEXT.split("/");
                    myArray.splice(0, 2);
                    let caption = '';
                    myArray.forEach((cap, i) => {
                        if(i >= 3){
                            return;
                        }

                        caption += cap +'/';
                    });

                    cat.caption = caption;

                    this.savedEngines.push(cat);
                });

                console.table(this.savedEngines);
            })
        },

        goToResults(val) {
            console.log(val);
            // lsel_saved
            this.lsel_option = this.savedEngines.find(e => {
                return e.LASTTEXT.trim() == val.trim();
            });
            
            this.lsel_year = this.lsel_option.DMCD02;
            this.getKitMakes();
            this.lsel_make = this.lsel_option.DMCD03;
            this.getKitEngines();          
            this.lsel_eng = this.lsel_option.DMCD04;
            this.getKitVIN();

            // this.lsel_vin = this.lsel_option.DMCD05;
            // this.getLvl6();
            // this.lsel_lvl6 = this.lsel_option.DMCD06;
            // this.getLvl7();
            // this.lsel_lvl7 = this.lsel_option.DMCD07;
            // this.getLvl8();
            // this.lsel_lvl8 = this.lsel_option.DMCD08;
            // this.getLvl9();
            // this.lsel_lvl9 = this.lsel_option.DMCD09;
            // this.getLvl10();
            // this.lsel_lvl10 = this.lsel_option.DMCD10;
        },

        setCaptions() {
            if (this.main_category == 'ENGKT'){
                this.vinShow = true;
                this.titleCaption = 'Select Engine';
                this.buttonCaption = 'Search Kits';
            }else{
                this.vinShow = true;
                this.titleCaption = 'Select Vehicle';
                this.buttonCaption = 'View Products';
            }
        },

        getNames() {
            const catlvl_names_uri = this.$store.getters['api/catlvl_names_uri'];
            this.savedEngines = [];
            axiosvl.post(catlvl_names_uri, {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "CATC": { "value": this.main_category },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                // console.table(fields);

                this.lvl1n = {
                    'caption' : fields.OAHDR1.value,
                    'sort'    : fields.OASRT1.value
                };

                this.lvl2n = {
                    'caption' : fields.OAHDR2.value,
                    'sort'    : fields.OASRT2.value
                };

                this.lvl3n = {
                    'caption' : fields.OAHDR3.value,
                    'sort'    : fields.OASRT3.value
                };

                this.lvl4n = {
                    'caption' : fields.OAHDR4.value,
                    'sort'    : fields.OASRT4.value
                };

                this.lvl5n = {
                    'caption' : fields.OAHDR5.value,
                    'sort'    : fields.OASRT5.value
                };

                this.lvl6n = {
                    'caption' : fields.OAHDR6.value,
                    'sort'    : fields.OASRT6.value
                };

                this.lvl7n = {
                    'caption' : fields.OAHDR7.value,
                    'sort'    : fields.OASRT7.value
                };

                this.lvl8n = {
                    'caption' : fields.OAHDR8.value,
                    'sort'    : fields.OASRT8.value
                };

                this.lvl9n = {
                    'caption' : fields.OAHDR9.value,
                    'sort'    : fields.OASRT9.value
                };

                this.lvl10n = {
                    'caption' : fields.OAHDRA.value,
                    'sort'    : fields.OASRTA.value
                };
                
            })
        },

        getCatPrescriptions() {
            const cat_prescript_uri = this.$store.getters['api/cat_prescript_uri'];
            this.savedEngines = [];
            console.log('cat_prescript_uri = ' + cat_prescript_uri);
            axiosvl.post(cat_prescript_uri, {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "CPRESCOD": { "value": this.main_category },
                        "LW3SFID": { "value": this.$store.getters.storefront },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                let max = 1;
                for (let key in fields) {
                    let f = fields[key];
                    if(f.value == 'Y'){
                        max++;
                    }
                }
                this.maxLevel = max;
                const SHWPRES_1 = fields.SHWPRESCA.value;
                const SHWPRES_2 = fields.SHWPRES_1.value;
                const SHWPRES_3 = fields.SHWPRES_2.value;
                const SHWPRES_4 = fields.SHWPRES_3.value;
                const SHWPRES_5 = fields.SHWPRES_4.value;
                const SHWPRES_6 = fields.SHWPRES_5.value;
                const SHWPRES_7 = fields.SHWPRES_6.value;
                const SHWPRES_8 = fields.SHWPRES_7.value;
                const SHWPRES_9 = fields.SHWPRES_8.value;
                
                this.DD1Show = (SHWPRES_1 == 'N' || SHWPRES_1 == '') ? false: true;
                this.DD2Show = (SHWPRES_2 == 'N' || SHWPRES_2 == '') ? false: true;
                this.DD3Show = (SHWPRES_3 == 'N' || SHWPRES_3 == '') ? false: true;
                this.DD4Show = (SHWPRES_4 == 'N' || SHWPRES_4 == '') ? false: true;
                this.DD5Show = (SHWPRES_5 == 'N' || SHWPRES_5 == '') ? false: true;
                this.DD6Show = (SHWPRES_6 == 'N' || SHWPRES_6 == '') ? false: true;
                this.DD7Show = (SHWPRES_7 == 'N' || SHWPRES_7 == '') ? false: true;
                this.DD8Show = (SHWPRES_8 == 'N' || SHWPRES_8 == '') ? false: true;
                this.DD9Show = (SHWPRES_9 == 'N' || SHWPRES_9 == '') ? false: true;
            })
        }
    },

    created() {

        // console.log(this.lyears);
    },

    updated() {
        // console.log('main_category = ' + this.main_category);
        this.getYears();

        this.lastCategories();
        this.getNames();

        if (this.main_category != 'ENGKT'){
            this.getCatPrescriptions();
        }

        this.setCaptions();
    }
}
</script>

<style scoped>
    /* dialog{
        padding: 7px !important;
    } */

    /* .dialog-close {
        z-index: 2;
    } */

    .vehicle-form__item.vehicle-form__item--select{
        /* width: 255px; */
        width: 100%;
    }

    .vehicle-form {
        /* width: 550px; */
        width: 100%;
    }
    
    .vehicle-form .vehicle-form__item{
        margin-top: 6px;
        margin-bottom: 6px;
        margin-right: 0px;
        margin-left: 0px;
    }
</style>